import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { scrollToTop } from "../utils/ScrollRestoration";

const MobileLayout = () => {
  const location = useLocation();
  const layoutRef = useRef(null);

  // Scroll restoration and scroll-to-top is now handled globally by the ScrollRestoration component
  // which is mounted in AppRouter. This avoids conflicts and redundant scroll events.

  return (
    <Box
      className="mobile-layout"
      sx={{
        width: '100vw',
        backgroundColor: '#f5f5f5',
        margin: 0,
        padding: 0,
        overflowX: 'hidden'
      }}
    >
      <Outlet />
    </Box>
  );
};

export default MobileLayout;
